export default __webpack_public_path__ + "static/logofolio@2x-1f7aae626e8f043053f494ec11bab6ba.png";